import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './DeleteAccount.css';

const DeleteAccount: React.FC = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!confirmDelete || !password) return;

    setIsDeleting(true);
    // Delete account logic
    setTimeout(() => {
      setIsDeleting(false);
      // Navigate to login or home
      navigate('/login');
    }, 2000);
  };

  return (
    <div className="delete-account-page">
      <header className="delete-account-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          ←
        </button>
        <h1>Delete Account</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="delete-account-content">
        {/* Warning Card */}
        <div className="warning-card">
          <div className="warning-icon">⚠️</div>
          <h2 className="warning-title">Delete Your Account?</h2>
          <p className="warning-message">
            This action cannot be undone. All your data, courses, progress, and certificates will be permanently deleted.
          </p>
        </div>

        {/* What Will Be Deleted */}
        <div className="deletion-info-card">
          <h3 className="card-title">What will be deleted:</h3>
          <ul className="deletion-list">
            <li>✓ Your profile and account information</li>
            <li>✓ All enrolled courses and progress</li>
            <li>✓ Quiz results and certificates</li>
            <li>✓ Payment history</li>
            <li>✓ All saved preferences</li>
          </ul>
        </div>

        {/* Confirmation Form */}
        <div className="confirmation-form-card">
          <h3 className="card-title">Confirm Deletion</h3>
          <p className="confirmation-instruction">
            To confirm, please enter your password and check the confirmation box below.
          </p>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="password-input"
            />
          </div>

          <label className="confirm-checkbox-label">
            <input
              type="checkbox"
              checked={confirmDelete}
              onChange={(e) => setConfirmDelete(e.target.checked)}
              className="confirm-checkbox"
            />
            <span>I understand that this action is permanent and cannot be undone</span>
          </label>
        </div>

        {/* Delete Button */}
        <button
          className={`delete-button ${confirmDelete && password ? 'active' : ''}`}
          onClick={handleDelete}
          disabled={!confirmDelete || !password || isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Permanently Delete Account'}
        </button>

        {/* Cancel Button */}
        <button
          className="cancel-button"
          onClick={() => navigate('/profile')}
        >
          Cancel
        </button>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default DeleteAccount;
